<div class="card">
  <div class="title">{{ title }}</div>
  <div *ngIf="numType === 'currency'" class="data">
    {{ num | currency: 'USD' : 'symbol' : '1.0-2' }}
  </div>
  <div *ngIf="numType === 'none'" class="data">
    {{ num | number: '1.0' : 'en-US' }}
  </div>
</div>
